import { FC } from "react";
import MenuDropdownWithoutOptions from "../atoms/MenuDropdownWithoutOptions"
import { MenuNames } from "../header";

type IProps = {
    onHover: (menu: MenuNames) => void;
}

const LargeScreenMenus: FC<IProps> = ({ onHover }) => {
    return (
        <div className="hidden lg:flex grow lg:gap-x-12">
            {/* id:desktopNavLinkBuy */}
            <MenuDropdownWithoutOptions onMouseEnter={() => {
                onHover('buy')
            }} label="Buy" />
            {/* id:desktopNavLinkSell */}
            <MenuDropdownWithoutOptions onMouseEnter={() => {
                onHover('sell')
            }} label="Sell" />
            {/* id:desktopNavLinkBuySell */}
            <MenuDropdownWithoutOptions onMouseEnter={() => {
                onHover('sell-buy')
            }} label="Upsize" />
        </div>
    )
}

export default LargeScreenMenus